<template>
    <div class="publish">
        <div>发布{{$route.name=='PublishJP'?'竞拍':'意向卖货'}}</div>
        <!-- <div>
            <div>发布类型</div>
            <div>
                <div>
                    发布竞拍
                </div>
                <div>
                    意向卖货
                </div>
            </div>
        </div> -->
        <div>
            <router-view />
        </div>
    </div>
</template>

<script>
    export default {
        name: "Publish",
        data() {
            return {}
        },
        created() {},
        methods: {}
    };
</script>

<style scoped>
    .publish {
        padding: 0 24px;
        text-align: left;
    }

    .publish>div:nth-child(1) {
        font-size: 18px;
        color: #333333;
        line-height: 70px;
        border-bottom: 1px solid #E6E6E6;
    }

    .publish>div:nth-child(2) {
        margin-top: 28px;
    }

    .publish>div:nth-child(2)>div:nth-child(1) {
        font-size: 16px;
        color: #333333;
    }

    .publish>div:nth-child(2)>div:nth-child(2) {
        display: flex;
        margin-top: 14px;
    }

    .publish>div:nth-child(2)>div:nth-child(2)>div {
        width: 170px;
        height: 72px;
        border: 1px solid #C7C7C7;
        border-radius: 10px;
        box-sizing: border-box;
        line-height: 70px;
        text-align: center;
        margin-right: 34px;
        font-size: 16px;
        color: #666666;
    }

    .publish>div:nth-child(3){

    }
</style>



// WEBPACK FOOTER //
// src/view/me/publish.vue